export default {
      id: "miles-logged-usage",
      viewBox: "0 0 57 67",
      url: __webpack_public_path__ + "icons/mvm-icons.svg#miles-logged",
      toString: function () {
        return this.url;
      }
    }